import Types from '../../action/types';
import Cookies from 'js-cookie';

const defaultState = {
  userEmail: {},
  userInfo: {}, //登录返回的回调数据
  fileListModal: null,
  tokenId: null,
  handleImgErr: [],
  userAction: false,
  authorization: Cookies.get('authorization') || Cookies.get('anonymousAuth'),
  purchaseModalObj: {
    visible: false,
    type: '',
  },
  advertiseDialog: false,
  advertiseConfig: {
    isShowBtn: false, //是否显示not Now 的按钮
    isShowHeader: false,
    headerObj: '', //是否显示对话框头部,以及展示类型
    titleIndex: 0, //标题
    imgIndex: 0, //图片展示
    source: '', //开启的原因，用于埋点 fontUrl：文字链接  exceed2G:上传2G大文件  format:格式原因  highSpeed:速度原因  exceed20M 超过20Mb
    //extract 提取音频  failed 提取失败 successful 提取成功
  },
  sku: 'Yearly',
  skSwitchOther: 'Monthly',
  exceed2M: {
    visible: false,
    text: 'Free account cannot upload image size that exceeds 2M.',
  },

  payBill: false,
  payTrigger: '',
  percent: 0,
  isHide: false,
  profileObj: null,
  subscription: null,
  videoEditorTimes: Cookies.get('videoEditorTimes')
    ? Number(Cookies.get('videoEditorTimes'))
    : 0, //当前用户处理视频数
  imageCutoutTimes: Cookies.get('imageCutoutTimes')
    ? Number(Cookies.get('imageCutoutTimes'))
    : 0, //当前用户处理图片去除背景数
  signUpModal: {
    visible: false,
  },
  emailToken: {}, //发送验证码返回的token
};

export default function onAction(state = defaultState, action) {
  switch (action.type) {
    case Types.FILELISTMODAL_CHANGE:
      return {
        ...state,
        fileListModal: action.fileListModal,
      };
    case Types.TOKENID_CHANGE:
      return {
        ...state,
        tokenId: action.tokenId,
      };
    case Types.HANDLEIMGERR_CHANGE:
      return {
        ...state,
        handleImgErr: action.handleImgErr,
      };
    case Types.USERACTION_CHANGE:
      return {
        ...state,
        userAction: action.userAction,
      };
    case Types.AUTHORIZATION_CHANGE:
      return {
        ...state,
        authorization: action.authorization,
      };
    case Types.PURCHASEMODALOBJ_CHANGE:
      return {
        ...state,
        purchaseModalObj: action.purchaseModalObj,
      };
    case Types.PROFILEOBJ_CHANGE:
      return {
        ...state,
        profileObj: action.profileObj,
      };
    case Types.SUBSCRIPTION_CHANGE:
      return {
        ...state,
        subscription: action.subscription,
      };
    case Types.VIDEOEDITORTIMES_CHANGE:
      return {
        ...state,
        videoEditorTimes: action.videoEditorTimes,
      };
    case Types.IMAGECUTOUTTIMES_CHANGE:
      return {
        ...state,
        imageCutoutTimes: action.imageCutoutTimes,
      };
    case Types.OPEN_ADVERTISE:
      return {
        ...state,
        advertiseDialog: action.advertiseDialog,
      };
    case Types.ADVERTISE_CONFIG: {
      return {
        ...state,
        advertiseConfig: action.advertiseConfig,
      };
    }
    case Types.DOWNLOAD_PERCENT: {
      return {
        ...state,
        percent: action.percent,
      };
    }
    case Types.HIDE_LINK: {
      return {
        ...state,
        isHide: action.isHide,
      };
    }
    case Types.PAYBILL:
      return {
        ...state,
        payBill: action.payBill,
      };
    case Types.PATRIGTER:
      return {
        ...state,
        payTrigger: action.payTrigger,
      };
    case Types.EXCEED2M:
      return {
        ...state,
        exceed2M: action.exceed2M,
      };
    case Types.SAVESKU:
      return {
        ...state,
        sku: action.sku,
      };
    case Types.SAVESWITCHOTHER:
      return {
        ...state,
        skSwitchOther: action.skSwitchOther,
      };
    case Types.SIGNUPMODAL:
      return {
        ...state,
        signUpModal: action.signUpModal,
      };
    case Types.LOGININ:
      return {
        ...state,
        userInfo: action.userInfo,
      };
    case Types.SENDVERIFICATION:
      return {
        ...state,
        emailToken: action.emailToken,
      };
    case Types.SAVEEMAIL:
      return {
        ...state,
        userEmail: action.userEmail,
      };

    default:
      return state;
  }
}
